/**
 * main.tsx - Application Entry Point
 *
 * Uses the original CareerCard provider stack from +Wrapper.tsx
 */
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import Wrapper from "./renderer/+Wrapper";
import App from "./App";
import "./index.css";

// Initialize dark mode based on system preference or stored preference
const initializeDarkMode = () => {
  const storedTheme = localStorage.getItem("theme");
  const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;

  if (storedTheme === "dark" || (!storedTheme && prefersDark)) {
    document.documentElement.classList.add("dark");
  } else {
    document.documentElement.classList.remove("dark");
  }
};

initializeDarkMode();

// Listen for system theme changes
window
  .matchMedia("(prefers-color-scheme: dark)")
  .addEventListener("change", (e) => {
    const storedTheme = localStorage.getItem("theme");
    if (!storedTheme) {
      if (e.matches) {
        document.documentElement.classList.add("dark");
      } else {
        document.documentElement.classList.remove("dark");
      }
    }
  });

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <Wrapper>
      <App />
    </Wrapper>
  </StrictMode>
);
